import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GridCell, RowCell, Section, StoreFeature, StoreFeatureOptions } from '../../models/sections-model';
import { RendererDataInterFace } from '../dynamic-renderer-model';

@Component({
  selector: 'kw-store-feature-renderer',
  templateUrl: './store-feature-renderer.component.html',
  styleUrls: ['./store-feature-renderer.component.scss']
})
export class StoreFeatureRendererComponent implements RendererDataInterFace, OnInit,AfterViewInit {
  @Input() data:Section;
  @Input() title:string;
  @Input() edit:boolean;
  rendererType:string;
  heading:string;
  features:StoreFeature[];
  invert?:boolean;
  cells:RowCell[];
  //rowCells:RowCell[];

  layoutClass:string;

  @ViewChild('backgroundWrapper', {read: ElementRef}) backgroundWrapper:ElementRef;

  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<RowCell>();

  constructor(private cdr: ChangeDetectorRef) { }
  
  ngOnInit(): void {
    /* console.log(this.data)
    console.log(this.edit);
    this.rendererType = this.data.rendererType? this.data.rendererType : null;
    this.cells = this.data.sectionData.rowOptions.rowCells;
    this.layoutClass =  this.data.sectionData.layoutClass;
    console.log(this.cells);
    this.heading = this.data.sectionData.heading? this.data.sectionData.heading : null; */
   // this.features = this.data.features? this.data.features : null;
    //this.invert = this.data.invert? this.data.invert : false;
  }

  ngAfterViewInit(): void {
    console.log(this.data)
    console.log(this.edit);
    this.rendererType = this.data.rendererType? this.data.rendererType : null;
    this.cells = this.data.sectionData.rowOptions.rowCells;
    this.layoutClass =  this.data.sectionData.layoutClass;
    console.log(this.cells);
    this.heading = this.data.sectionData.heading? this.data.sectionData.heading : null;
    this.cdr.detectChanges();
    if(this.invert == true){
      this.backgroundWrapper.nativeElement.classList.add("invert");
    }
  }

  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }
  updateSection(section:Section){
    console.log(section);
    this.data = section;
    this.cells = section.sectionData.rowOptions.rowCells;
    console.log(this.cells);
    this.cdr.detectChanges();
  }


}
